import React, { useRef, lazy, Suspense } from 'react';
import LandingNavbar from '../components/LandingNavbar';
import HeroSection from '../components/HeroSection';
import './LandingPage.css';

// Lazy load below-the-fold sections for better mobile performance
const CleaningSection = lazy(() => import('../components/CleaningSection'));
const WhoWeWorkWithSection = lazy(() => import('../components/WhoWeWorkWithSection'));
const ComplianceSection = lazy(() => import('../components/ComplianceSection'));
const ContractsWorkSection = lazy(() => import('../components/ContractsWorkSection'));
const CTASection = lazy(() => import('../components/CTASection'));
const ContactSection = lazy(() => import('../components/ContactSection'));
const FAQSection = lazy(() => import('../components/FAQSection'));
const Footer = lazy(() => import('../components/Footer'));

// Loading placeholder for lazy-loaded sections
const SectionLoader = () => (
  <div style={{ 
    minHeight: '200px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center',
    background: '#f5f7fa'
  }}>
    <div style={{ 
      width: '40px', 
      height: '40px', 
      border: '4px solid #e0e0e0',
      borderTop: '4px solid #2E9BF5',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite'
    }} />
  </div>
);

const LandingPage: React.FC = () => {
  const ctaRef = useRef<HTMLDivElement>(null);

  const handleGetStarted = () => {
    ctaRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="landing-page">
      <LandingNavbar onGetStarted={handleGetStarted} />
      <HeroSection />
      <Suspense fallback={<SectionLoader />}>
        <WhoWeWorkWithSection />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <ComplianceSection />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <ContractsWorkSection />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <CleaningSection />
      </Suspense>
      <div ref={ctaRef}>
        <Suspense fallback={<SectionLoader />}>
          <CTASection />
        </Suspense>
      </div>
      <Suspense fallback={<SectionLoader />}>
        <ContactSection />
      </Suspense>
      <Suspense fallback={<SectionLoader />}>
        <FAQSection />
      </Suspense>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default LandingPage;
